// modules
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HashLocationStrategy, Location, LocationStrategy } from '@angular/common';
import { HttpModule, Http, RequestOptions, XSRFStrategy, CookieXSRFStrategy } from '@angular/http';
import { MaterializeModule } from 'angular2-materialize';
import { routing, appRoutingProviders } from './app.routing';
import { Ng2PaginationModule } from 'ng2-pagination';

// external components
import { AuthHttp, AuthConfig, AUTH_PROVIDERS } from 'angular2-jwt';
// internal components
import { AppComponent } from './app.component';
import { AccountadminComponent } from './accountadmin/accountadmin.component';
import { BernieComponent } from './bernie/bernie.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { CompareviewComponent } from './compareview/compareview.component';
import { CommonService } from './navbar/searchCommon.service';
import { CustomersComponent } from './customers/customers.component';
import { DropzoneAttachComponent } from './dropzone/dropzone-attach.component';
import { DropzoneAttach2Component } from './dropzone/dropzone-attach2.component';
import { DropzoneComponent } from './dropzone/dropzone.component';
import { DropzoneWorkspaceComponent } from './dropzone/dropzone-workspace.component';
import { MaterialadminComponent } from './materialadmin/materialadmin.component';
import { MRLoginComponent } from './login/login.component';
import { MRRegisterComponent } from './register/register.component';
import { NavbarComponent } from './navbar/navbar.component';
import { ProjectinfoComponent } from './projectinfo/projectinfo.component';
import { PdfviewerComponent } from './pdfviewer/pdfviewer.component';
import { ProjectsComponent } from './projects/projects.component';
import { QuoteComponent } from './quote/quote.component';
import { QuotedocumentComponent } from './quotedocument/quotedocument.component';
import { RecipesComponent } from './recipes/recipes.component';
import { RegisterconfirmComponent } from './registerconfirm/registerconfirm.component';
import { ResourceadminComponent } from './resourceadmin/resourceadmin.component';
import { SetpasswordComponent } from './setpassword/setpassword.component';
import { ShapesearchComponent } from './shapesearch/shapesearch.component';
import { ShareviewComponent } from './shareview/shareview.component';
import { SuperimposeComponent } from './superimpose/superimpose.component';
import { UseradminComponent } from './useradmin/useradmin.component';
import { ViewerComponent } from './Viewer/viewer.component';
import { WorkspaceComponent } from './workspace/workspace.component';
import { ShareModelComponent } from './sharemodel/sharemodel.component';
import { TranslateModelComponent } from './translatemodel/translatemodel.component';
import { UploadModelComponent } from './uploadmodel/uploadmodel.component';
import { ClipboardModule } from 'ngx-clipboard';
import { DeleteModelComponent } from './deletemodel/deletemodel.component';
import { CreateProjectComponent } from './createproject/createproject.component';
import { AdvancedSearchComponent } from './search/advanced/advancedsearch.component';
import { AdvancedSearchChipsComponent } from './search/chips/searchchips.component';
import { BasicSearchComponent } from './search/basic/basicsearch.component';
import { BackButtonComponent } from './shared/inAppBack/back-button/back-button.component';
import { CreateCustomerComponent } from './createcustomer/createcustomer.component';
// services
import { GetFileSizeStringService } from './shared/getFileSize/get-file-size-string.service';
import { GetFileTypeService } from './shared/getFileType/get-file-type.service';
import { ProjectsService } from './projects/projects.service';
import { ProjectDataService } from './shared/dataservice.service';
import { SharedService } from './shared/shared.service';
import { UploadService } from './shared/upload.service';
import { UtilsService } from './shared/utils.service';
import { UserLoginService } from './cognito/user-login.service';
import { CognitoUtil } from './cognito/cognito.service';
import { NavbarService } from './navbar/navbar.service';
import { DatePipe } from '@angular/common';

// pipes
import { FilesizePipe } from './projects/filesize.pipe';
import { StringFilterPipe } from './projects/stringfilter.pipe';
import { CommaReplacerPipe } from './shared/comma-replacer.pipe';
// directives
import { CustomEventDirective } from './customevent/customEvent.directive';
// guards
import { AuthGuard } from './cognito/auth.guard';



export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig({
    tokenName: 'token',
    tokenGetter: (() => localStorage.getItem('token')),
    globalHeaders: [{ 'Content-Type': 'application/json' }],
  }), http, options);
}

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    Ng2PaginationModule,
    routing,
    MaterializeModule,
    ClipboardModule
  ],
  declarations: [
    AppComponent,
    MRLoginComponent,
    MRRegisterComponent,
    NavbarComponent,
    ChangepasswordComponent,
    ProjectinfoComponent,
    RegisterconfirmComponent,
    ProjectsComponent,
    ShapesearchComponent,
    ViewerComponent,
    ShareviewComponent,
    UseradminComponent,
    FilesizePipe,
    StringFilterPipe,
    WorkspaceComponent,
    CompareviewComponent,
    SuperimposeComponent,
    DropzoneComponent,
    DropzoneAttachComponent,
    DropzoneAttach2Component,
    DropzoneWorkspaceComponent,
    CustomEventDirective,
    BernieComponent,
    SetpasswordComponent,
    CustomersComponent,
    QuoteComponent,
    ResourceadminComponent,
    MaterialadminComponent,
    RecipesComponent,
    QuotedocumentComponent,
    AccountadminComponent,
    PdfviewerComponent,
    CommaReplacerPipe,
    ShareModelComponent,
    TranslateModelComponent,
    UploadModelComponent,
    DeleteModelComponent,
    CreateProjectComponent,
    AdvancedSearchComponent,
    AdvancedSearchChipsComponent,
    BasicSearchComponent,
    BackButtonComponent,
    CreateCustomerComponent
  ],
  exports: [
    UploadModelComponent
  ],
  providers: [
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    },
    UserLoginService,
    CognitoUtil,
    appRoutingProviders,
    CommonService,
    CommaReplacerPipe,
    GetFileSizeStringService,
    GetFileTypeService,
    ProjectDataService,
    ProjectsService,
    SharedService,
    UploadService,
    UtilsService,
    AuthGuard,
    NavbarService,
    DatePipe,
  { provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/app.module.ts